import React, { useState, useEffect, useCallback} from "react";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LockIcon from '@material-ui/icons/Lock';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import WDList from './withdrawList'
import Menu from '../../../Components/LockerMenu'
import Footer from '../../../Components/Footer'
import '../browser.css'
import Lock from '../../../images/lockicon.png'
import Busd from '../../../images/fantomicon.png'  
import {lockerContract} from '../../../Contracts/QMF-contract';




/* ***********************
**   Import Web3
*********************** */
import Web3 from "web3";

var web3;
let contract;
let finalAccount;
let accounts

const today = new Date();

const DetailedPage = (props) => {
  const [tabVal, settabVal] = useState(0)
  let url_string = window.location.href;
  let url = new URL(url_string);
  let pramValue = url.searchParams.get("pair");


  const [useKTRInLP, setKTRInLP] = useState()
  const [useKSCInLP, setKSCInLP] = useState()
  const [useTotalLPofToken, setTotalLPofToken] = useState()
  const [useTotalPercentageOfLockedLP, setTotalPercentageOfLockedLP] = useState(0)
  const [useTotalLokedLPofToken, setTotalLokedLPofToken] = useState(0)
  const [useWidrawDate, setWidrawDate] = useState(0)
  const [useSearchCoinSymbolPOne, setSearchCoinSymbolPOne] = useState()
  const [useSearchCoinSymbolPOneIcon, setSearchCoinSymbolPOneIcon] = useState()
  const [useSearchCoinSymbolPTwo, setSearchCoinSymbolPTwo] = useState()
  
  const [useAddressArray, setAddressArray] = useState([])

  const [useitemList, setitemList] = useState('No Data')

  const [usewalletBtn, setwalletBtn] = useState(true)  
  const [useWalletNT, setWalletNT] = useState(false)
  const [usebodyScreen, setbodyScreen] = useState(false)

  
  let itemList;
  var all_data_array = [];

  useEffect(()=> {
    connectWallet();
    fetchData();
  },[pramValue]);

  const connectWallet = () => {
    if(window.web3 !== undefined){
      //connect to web3
      web3 = new Web3(window.ethereum);

      window.ethereum.request({ method: 'eth_requestAccounts' }).then(_accounts => {
          accounts = _accounts;
          finalAccount = accounts[0];
          setwalletBtn(false) 
          web3.eth.getChainId().then( _chainId => {
            if( _chainId != 250){
              setbodyScreen(false)
              setWalletNT(true)
            }else{
              setWalletNT(false)
              setbodyScreen(true)
            }
          });
          
          lockerContract.methods.getUserNumLocksForToken(finalAccount , pramValue).call().then( numLockedTokens => {
            handleNoOfToken(numLockedTokens)
          })
          
      });  
    }
    else{
        //if Metamask is not installed
    }
  }
  
  const handleNoOfToken = (val) => {
    for( let i = 0 ; i <= val-1 ; i++ ){
      lockerContract.methods.getUserLockForTokenAtIndex(finalAccount , pramValue , i).call().then( lockedTokenAtIndex => {
        lockedTokenAtIndex["6"] = i;
        all_data_array.push(lockedTokenAtIndex);
        setAddressArray([ ...useAddressArray, lockedTokenAtIndex]);
        console.log('Grow ip: ' , all_data_array)
        setGetList();
      })
    }
  }

  const compareSecondColumn = (a, b) => {
    if (a[4] === b[4]) {
        return 0;
    }
    else {
        return (a[4] < b[4]) ? -1 : 1;
    }
  }
  const reducer = (accumulator, curr) => accumulator + curr;
  const fetchData = () => {

    if(window.web3 !== undefined){
      web3 = new Web3(window.ethereum);
      try {
        let addreabiss =  [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}];

        contract = new web3.eth.Contract(addreabiss, pramValue)
  
        contract.methods.token0().call().then( result => {
          findPair(result,'one')
        })
        contract.methods.token1().call().then( result => {
          findPair(result,'two')
        })
      } catch(error) {
        console.log('Error getting fake data All: ' + error);
      }
    }else{
      alert('Connect your wallet first..!')
    }

  }
  const setGetList = () => {
    setitemList(all_data_array.map((item,index)=>{ 
      return (
        <WDList
          key={index}
          userVal={finalAccount}
          lpAddress={pramValue}
          indexVal={item[6]}
          amount={item[1]}
          lockId={item[4]} 
          widrawDate={item[3]} 
        />
      );
    }))
  }

  function daysConvert(date2) {
    let date1 = new Date();
    let oned = 30 * 24 * 60 * 60 * 1000;
    return Math.ceil((date2 - date1) / oned);
  }
  const findPair = (val,pairno) => {
        try{
          //connect to web3
          web3 = new Web3(window.ethereum);
          let addreabissPair =  [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"sync","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}];

          let contractPair = new web3.eth.Contract(addreabissPair, val);
          contractPair.methods.symbol().call().then( result => {
            if( pairno == 'one' ){
              setSearchCoinSymbolPOne(result)
              let str = result;
              let res = str.substring(0, 1);
              setSearchCoinSymbolPOneIcon(res)
            }else if ( pairno == 'two' ){
              setSearchCoinSymbolPTwo(result)
            }
          });
        } catch(error) {
          console.log('Error getting pair data: ' + error);
        }
  }
  function kFormatter(num) {
    if(num > 999 && num < 999999){
      return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + ' K' : Math.sign(num)*Math.abs(num)
    }else if(num > 999999){
      return Math.abs(num) > 999999 ? Math.sign(num)*((Math.abs(num)/1000000).toFixed(1)) + ' M' : Math.sign(num)*Math.abs(num)
    }
  }
  const financial = (num,digit,sint) => {
    if (sint == 'yes') {
      let val = num/1e18;
      return Number.parseFloat(val).toFixed(digit);
    }else{
      return Number.parseFloat(num).toFixed(digit);
    }
  }
  const pickDuplicate = arr => {
    const res = [];
    for(let i = 0; i < arr.length; i++){
       if(arr.indexOf(arr[i]) !== arr.lastIndexOf(arr[i])){
          if(!res.includes(arr[i])){
             res.push(arr[i]);
          };
       };
    };
    return res;
 };


  let hrefLink = "/lp-lock?pair=" + pramValue;
  
  return (
    <div className="pcc---slider">
      <Menu />
        <Container maxWidth="lg">
            <Grid
              container
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid 
                  xs={12}
                  className="text-left pb-4"
              >
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className="px-0"
                >
                  { usewalletBtn ? 
                    <Grid 
                      container 
                      justify="center" 
                      direction="row"
                      md={8}
                      xs={12}
                      className="py-5 mt-4 Token--locker px-sm-5 "
                    >
                      <Grid 
                        justify="center" 
                        direction="column"
                        alignContent='center'
                        alignItems="center"
                        xs={12}
                        style={{alignSelf: 'center'}}
                      >
                        <button className="collect--wallet py-4" onClick={connectWallet}>
                          <AccountBalanceWalletIcon style={{width: '35px',marginTop: '-11px'}} /><span className="h3"><strong>Connect Wallet</strong></span>
                        </button>
                      </Grid>
                    </Grid>
                  :
                    <p className="m-0" />
                  }

                  {useWalletNT ? 
                    <Grid 
                    container 
                    justify="center" 
                    direction="row"
                    md={8}
                    xs={12}
                    className="py-5 mt-4 Token--locker px-sm-5 "
                  >
                    <Grid 
                      justify="center" 
                      direction="column"
                      alignContent='center'
                      alignItems="center"
                      xs={12}
                      style={{alignSelf: 'center'}}
                    >
                      <p className="mb-2 text-danger"><b>Error: </b>Please set Fantom as your active network</p>
                    </Grid>
                  </Grid>
                    :
                    <p className="m-0" />
                  }
                  {usebodyScreen ?
                    <Grid 
                      container 
                      justify="center" 
                      direction="row"
                      md={8}
                      xs={12}
                      className="py-5 mt-4 Token--locker px-sm-5 "
                    >
                      <Grid 
                          justify="center" 
                          direction="column"
                          xs={12}
                          md={6}
                          className="QMD---BackButton"
                      >
                        <Link to="/locker">
                          <ArrowBackIcon />
                        </Link>
                      </Grid>
                      <Grid 
                          direction="column"
                          justify="flex-end" 
                          alignItems="flex-end"
                          xs={12}
                          md={6}
                          className="text-right QMD---lockedButton"
                      >
                        <Link to={hrefLink}>
                          <LockIcon /> Lock Liquidity
                        </Link>
                      </Grid>
                      <Grid 
                          container 
                          justify="center" 
                          direction="column"
                          md={12}
                          className="mt-5"
                      >
                        <img className="mx-auto" src={Lock} alt="Lock Logo" />
                          
                        <h2 className="text-center text-light pt-1 "><strong>{kFormatter(useTotalLokedLPofToken)}</strong></h2>
                        <h6 className="text-center text-light "><strong>Total Liquidity Locked for</strong></h6>
                        <h4 className="mt-3 text-light d-flex mb-0 text-center text-light" style={{alignSelf:'center',justifyContent: 'center'}}>
                          { useSearchCoinSymbolPOne != 'WFTM' ?  
                            <span className='QMF---locker-sybmol'>{useSearchCoinSymbolPOneIcon}</span> 
                            :
                            <img src={Busd} style={{height:"100%",width:'auto',maxHeight:28,marginRight: 5}}/>
                          }
                          <strong>{useSearchCoinSymbolPOne}</strong>
                          <strong className="mx-2 d-inline-block">/</strong>
                          { useSearchCoinSymbolPTwo != 'WFTM' ?  
                            <span className='QMF---locker-sybmol'>{useSearchCoinSymbolPOneIcon}</span> 
                            :
                            <img src={Busd} style={{height:"100%",width:'auto',maxHeight:28,marginRight: 5}}/>
                          }
                          <strong>{useSearchCoinSymbolPTwo}</strong>
                        </h4>
                      </Grid>
                      <Grid 
                          justify="center" 
                          direction="column"
                          xs={12}
                          className="text-center mb-3 QMD---lockedButton QMD---AddButton"
                      >
                        <a href="#">
                          {pramValue} 
                          {/* <FileCopyIcon className="ml-2" /> */}
                        </a>
                      </Grid>

                      <Grid 
                          container 
                          justify="space-between" 
                          direction="row"
                          xs={12}
                          className="my-4"
                      >
                        <Grid 
                          container 
                          justify="space-between" 
                          direction="row"
                          xs={6}
                          className="my-2"
                        >
                          <h5 className="text-light">Value</h5>
                        </Grid>
                        <Grid  
                          justify="space-between" 
                          direction="row"
                          xs={6}
                          className="my-2"
                        >
                          <h5 className="text-light text-right">Unlock date</h5>
                        </Grid>
                        {useitemList}
                      </Grid>
                    </Grid>
                  :
                    <p className="m-0" />
                  }
                </Grid>
              </Grid>
            </Grid>
        </Container>
      <Footer />
    </div> 
  );
}

export default DetailedPage;
